const config = {
	apiBaseUrl: 'https://bzzt.ndfnz.io/api'
};

export default config;
